import type { RequestInitiator } from '@ms/yammer-telemetry-support';
import { v4 as uuidv4 } from 'uuid';

import type { ManagedApiRequest } from '../../api';

export const getOcpsPoliciesRequest = (
  host: string,
  requestHash: string | undefined,
  initiator?: RequestInitiator
): ManagedApiRequest => ({
  method: 'GET',
  host,
  path: '/user/v1.0/web/policies',
  apiName: 'OCPS',
  requestType: 'Ocps',
  scopes: [`${host}/.default`],
  resource: host,
  query: requestHash ? { PoliciesHash: requestHash } : undefined,
  headers: {
    'x-Cid': uuidv4(),
  },
  initiator,
});
